// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6f6c2edd","977":"8736466a"}[chunkId] + ".chunk.js";
};